export const QUERY_KEYS = {
    language_of_message: 'language-of-message'
}
export const MUTATION_KEYS = {
    translation: 'translation'
}
